import "core-js/stable";
import "regenerator-runtime/runtime";

import React from 'react';
import { createRoot } from 'react-dom/client';
import loadable from '@loadable/component';
import {
  createRoutesFromElements,
  Route,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import Config from 'config';
import { Bugfender } from "@bugfender/sdk";
import * as CartLoggerEnabled from 'hooks/cartLoggerEnabled';
import ShoppingCart from "../vue/cart/cart";
import Tax from "../vue/cart/tax";
import User from "../vue/auth/user";

const { cartLoggerEnabled } = CartLoggerEnabled;
const cartPageElement = document.getElementById('cart');
const CartPage = loadable(() => import('pages/checkout/CartPage'));
const CheckoutPage = loadable(() => import('pages/checkout/CheckoutPage'));

const RouterComponent = () => {
  const cart = new ShoppingCart();
  const user = new User();
  const tax = new Tax();

  const checkoutDataLoader = async () => {
    if (cartLoggerEnabled) {
      Bugfender.init({
        appKey: Config.BugFenderAppKey,
        printToConsole: true,
        logBrowserEvents: true,
        logUIEvents: true
      });
    }
    await cart.setup();
    await user.handleInit(cart);
    return {
      cart, user, tax, Bugfender, cartLoggerEnabled
    };
  };

  const checkoutRoutes = [
    <Route
      path="/cart_items"
      loader={checkoutDataLoader}
      element={<CartPage />}
    />,
    <Route
      path="/checkout"
      loader={checkoutDataLoader}
      element={<CheckoutPage />}
    />
  ];
  const router = createBrowserRouter(createRoutesFromElements(checkoutRoutes), {
    future: {
      v7_startTransition: true,
    },
  });
  return (
    <RouterProvider router={router}>
      <CartPage />
    </RouterProvider>
  );
};
if (cartPageElement) {
  const cartRoot = createRoot(cartPageElement);
  cartRoot.render(
    <RouterComponent />
  );
}
